export default "__VITE_ASSET__Bk6El_A7__"